var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReject = function SvgReject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44",
    d: "M10 20.5c5.516 0 10-4.484 10-10S15.516.5 10 .5 0 4.984 0 10.5s4.484 10 10 10M5.706 7.173l.967-.967a.42.42 0 0 1 .591 0L10 8.942l2.736-2.736a.42.42 0 0 1 .591 0l.967.967a.42.42 0 0 1 0 .591L11.558 10.5l2.736 2.736a.42.42 0 0 1 0 .591l-.966.967a.42.42 0 0 1-.592 0L10 12.058l-2.736 2.736a.42.42 0 0 1-.591 0l-.967-.966a.42.42 0 0 1 0-.592L8.442 10.5 5.706 7.764a.42.42 0 0 1 0-.591"
  })));
};
export default SvgReject;